import CarrotClient from "lib/carrot-api"
import Settings from "./CarrotConfig"

// @ts-expect-error TS7009
export const adminCarrotClient = new CarrotClient(Settings.CARROT_BACKEND_ADMIN_URL)
// @ts-expect-error TS7009
export const carrotClient = new CarrotClient(Settings.CARROT_BACKEND_URL)
